<aside class="ic-panel" role="dialog" aria-label="Invoice chat">
  <header class="ic-header">
    <div class="ic-header-left">
      <div class="ic-avatar">
        <img *ngIf="headerOrg()?.logo as logo" [src]="logo" alt="" />
        <ng-container *ngIf="!headerOrg()?.logo">
          <mat-icon>business</mat-icon>
        </ng-container>
      </div>
      <div class="ic-org">
        <p class="ic-org-name">{{ headerOrg()?.orgName || 'Chat' }}</p>
        <span class="ic-invoice-pill">Invoice-{{ invoice?.invoiceRefNo || '' }}</span>
      </div>
    </div>
    <button type="button" class="ic-close" (click)="onClose()" aria-label="Close chat">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="ic-body">
    <div class="ic-messages" #scrollContainer>
      <ng-container *ngIf="loading && renderItems.length === 0">
        <div class="ic-empty">Loading messages…</div>
      </ng-container>

      <ng-container *ngIf="!loading && renderItems.length === 0">
        <div class="ic-empty">No messages yet. Start the conversation.</div>
      </ng-container>

      <ng-container *ngFor="let item of renderItems; trackBy: trackByRenderItem">
        <div *ngIf="item.type === 'date'" class="ic-date-divider">
          <span class="ic-date-line"></span>
          <span class="ic-date-label">{{ item.dateLabel }}</span>
          <span class="ic-date-line"></span>
        </div>

        <ng-container *ngIf="item.type === 'message'">
          <div class="ic-bubble-row" [class.is-own]="item.isOwn">
            <div
              class="ic-bubble"
              [class.ic-bubble-own]="item.isOwn"
              [attr.data-msg-id]="item.id">
              <button
                type="button"
                class="ic-reply-btn"
                (click)="startReply(item.message)"
                aria-label="Reply">
                <mat-icon>reply</mat-icon>
              </button>

              <div
                *ngIf="item.message?.replyTo as rep"
                class="ic-quoted"
                [class.ic-quoted-own]="item.isOwn"
                (click)="scrollToMessage(rep.messageId)">
                <span class="ic-quoted-bar"></span>
                <div class="ic-quoted-body">
                  <p class="ic-quoted-sender">{{ rep.senderName || 'Message' }}</p>
                  <p class="ic-quoted-text">{{ rep.text }}</p>
                </div>
              </div>

              <p *ngIf="!item.isOwn && !item.message?.replyTo" class="ic-sender">{{ item.message?.sentByName }}</p>
              <p class="ic-text">{{ item.message?.text }}</p>
              <p class="ic-time">
                {{ item.timeLabel }}
                <ng-container *ngIf="item.isOwn && (item.message?.readBy?.length || 0) > 1">
                  · Read
                </ng-container>
              </p>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <footer class="ic-footer">
      <div *ngIf="replyingTo" class="ic-reply-preview">
        <span class="ic-reply-bar"></span>
        <div class="ic-reply-body">
          <p class="ic-reply-sender">Replying to {{ replyingTo.senderName }}</p>
          <p class="ic-reply-text">{{ replyingTo.text }}</p>
        </div>
        <button type="button" class="ic-reply-cancel" (click)="cancelReply()" aria-label="Cancel reply">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="ic-footer-row">
        <button type="button" class="ic-attach" aria-label="Attach" disabled>
          <mat-icon>add_circle_outline</mat-icon>
        </button>
        <div class="ic-input-wrap">
          <input
            type="text"
            class="ic-input"
            [(ngModel)]="draft"
            (keydown)="onInputKeydown($event)"
            placeholder="Write a message"
            [disabled]="!chatService.canChat(invoice, currentOrgId)"
          />
        </div>
        <button
          type="button"
          class="ic-send"
          (click)="send()"
          [disabled]="!canSend()"
          aria-label="Send">
          <mat-icon>send</mat-icon>
        </button>
      </div>
    </footer>
  </div>
</aside>
